import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";

const DV360Icon = {
  name: 'DV360Icon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function (s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function (h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' 
      ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em'
      : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 2192.7 2428.1",
        fill: "none",
        "stroke-width": "0px"
      },
      "class": "feather feather-dv360"
    }, ctx.data]), [
      h("path", {
        attrs: {
          d: "M1730.6,949.3c142.5-86.5,328.1-41.1,414.5,101.4c86.5,142.5,41.1,328.1-101.4,414.5c-3.8,2.3-7.6,4.5-11.4,6.6L460.2,2377.1c-142.5,86.5-328.1,41.1-414.6-101.4c-86.5-142.5-41.1-328.1,101.4-414.6c3.8-2.3,7.6-4.5,11.4-6.6L1730.6,949.3z",
          stroke: "currentColor",
          "stroke-width": "20",
          fill: "none"
        }
      }),
      h("path", {
        attrs: {
          d: "M601,303.7C601.7,137.4,467.4,1.9,301.1,1.2c-21.4-0.1-42.7,2.1-63.7,6.5C96.5,42.3-2,169.5,0,314.7v1798.1l600.4,10.9L601,303.7z",
          stroke: "currentColor",
          "stroke-width": "20",
          fill: "none"
        }
      }),
      h("path", {
        attrs: {
          d: "M1737.4,1472.9c145.3,75.3,324.1,27.1,411.9-111.1c84.4-142,37.7-325.6-104.3-410c-1.1-0.6-2.1-1.2-3.2-1.9L459.2,43C318.3-42.1,135,3.1,49.8,144c-2.1,3.5-4.2,7.1-6.2,10.7C-40,297.8,8.2,481.7,151.3,565.4c1,0.6,2,1.1,3,1.7L1737.4,1472.9z",
          stroke: "currentColor",
          "stroke-width": "20",
          fill: "none"
        }
      }),
      h("path", {
        attrs: {
          d: "M2031.4,1475L600.5,2274.3v-686.6l1135.4-633.1c150.5-83.4,340.2-29,423.6,121.6c7.8,14,14.4,28.6,19.9,43.6C2222,1258.3,2159.8,1407.6,2031.4,1475z",
          stroke: "currentColor",
          "stroke-width": "20",
          fill: "none"
        }
      }),
      h("circle", {
        attrs: {
          cx: "300.8",
          cy: "2127.8",
          r: "300.2",
          stroke: "currentColor",
          "stroke-width": "20",
          fill: "none"
        }
      })
    ]);
  }
};

export default DV360Icon; 